var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "submit-tender clearfix",
      staticStyle: { display: "inline-block" },
    },
    [
      _c("modal", { ref: "alertModal", attrs: { modalId: "alert-modal" } }, [
        _c("div", { attrs: { slot: "content" }, slot: "content" }, [
          _c("p", { staticClass: "modal-pure-text" }, [
            _vm._v(_vm._s(_vm.$t("project.docs.approveAlert"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--darkblue",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.closeAlertModal()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.approve()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("action.accept")))]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }